<script setup>
import SvgIcon from '@/components/base/SvgIcon.vue';

const emit = defineEmits(['lineVerify']);
const route = useRoute();
const generateCsrfToken = (length) => {
    // 定義可能出現在字符串中的所有字符
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    var result = '';
    // 通過隨機選擇字符並連接到結果字符串上來生成指定長度的隨機字符串
    for (var i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
};
const LINEAuthSettings = {
    ClientId: import.meta.env.VITE_LINE_CLIENTID,
    ClientSecret: import.meta.env.VITE_LINE_CLIENTSECRET,
    // RedirectUri: 'https://localhost:3001/login',
    RedirectUri: location.origin + '/login',
    state: generateCsrfToken(10),
    scope: `profile%20openid%20email`
};

const lineLogin = () => {
    sessionStorage.setItem('thirdPartySigUp', 'Line');
    const url = `https://access.line.me/oauth2/v2.1/authorize?response_type=code&client_id=${LINEAuthSettings.ClientId}&redirect_uri=${LINEAuthSettings.RedirectUri}&state=${LINEAuthSettings.state}&scope=${LINEAuthSettings.scope}&nonce=09876xyz&bot_prompt=aggressive&prompt=consent`;
    const res = fetch(url);
    window.open(url, '_self');
};

onMounted(async () => {
    // const urlCode = route.query.code;
    // if (urlCode === undefined) return;
    // const params = new URLSearchParams();
    // params.append('grant_type', 'authorization_code');
    // params.append('code', urlCode);
    // params.append('redirect_uri', LINEAuthSettings.RedirectUri);
    // params.append('client_id', LINEAuthSettings.ClientId);
    // params.append('client_secret', LINEAuthSettings.ClientSecret);
    // try {
    //     let res = await fetch(`https://api.line.me/oauth2/v2.1/token`, {
    //         method: 'POST',
    //         headers: {
    //             'Content-Type': 'application/x-www-form-urlencoded'
    //         },
    //         body: params
    //     });
    //     if (!res.ok) {
    //         throw new Error();
    //     }
    //     res = await res.json();
    //     const id_token = jwtDecode(res.id_token);
    //     localStorage.setItem('from-third-party-type', '3');
    //     localStorage.setItem('from-third-party-id', id_token?.sub);
    //     if (id_token.email !== '') localStorage.setItem('from-third-party-email', id_token.email);
    //     emit('lineVerify', res.access_token);
    // } catch {
    //     console.log('error');
    // }
});
</script>
<template>
    <div class="line-third-card" @click="lineLogin">
        <SvgIcon style="width: 32px; height: 32px" class="md" name="line" />
    </div>
</template>
<style scoped lang="scss">
.line-third-card {
    cursor: pointer;
}
</style>
